import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  FormControl,
  FormLabel,
  Input,
  Button,
  Alert,
  AlertIcon,
  useColorModeValue,
} from '@chakra-ui/react';
import { useApp } from '../context/AppContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, currentUser } = useApp();
  const navigate = useNavigate();
  
  // Color mode values
  const bgGradient = useColorModeValue(
    'linear(to-br, primary.500, primary.700)',
    'linear(to-br, gray.900, gray.800)'
  );
  const cardBg = useColorModeValue('white', 'gray.800');
  const headingColor = useColorModeValue('gray.800', 'white');
  const textColor = useColorModeValue('gray.600', 'gray.300');

  // Redirect if already logged in
  useEffect(() => {
    if (currentUser) {
      navigate('/cases', { replace: true });
    }
  }, [currentUser, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      setError('يرجى إدخال اسم المستخدم وكلمة المرور');
      return;
    }

    try {
      const success = await login(username, password);
      if (success) {
        navigate('/cases');
      } else {
        setError('اسم المستخدم أو كلمة المرور غير صحيحة');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('حدث خطأ أثناء تسجيل الدخول. يرجى المحاولة مرة أخرى.');
    }
  };

  return (
    <Box
      minH="100vh"
      bgGradient={bgGradient}
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={4}
    >
      <Container maxW="md">
        <Box
          bg={cardBg}
          borderRadius="lg"
          boxShadow="xl"
          p={8}
          w="100%"
        >
          <VStack spacing={6} align="stretch">
            <Box textAlign="center">
              <Heading size="lg" color={headingColor} mb={2}>
                نظام إدارة قضايا البصمات الجنائية
              </Heading>
              <Text color={textColor}>تسجيل الدخول</Text>
            </Box>

            <form onSubmit={handleSubmit}>
              <VStack spacing={4}>
                {error && (
                  <Alert status="error" borderRadius="md">
                    <AlertIcon />
                    {error}
                  </Alert>
                )}

                <FormControl isRequired>
                  <FormLabel>اسم المستخدم</FormLabel>
                  <Input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="أدخل اسم المستخدم"
                    autoFocus
                    size="lg"
                  />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel>كلمة المرور</FormLabel>
                  <Input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="أدخل كلمة المرور"
                    size="lg"
                  />
                </FormControl>

                <Button
                  type="submit"
                  colorScheme="primary"
                  size="lg"
                  w="100%"
                >
                  تسجيل الدخول
                </Button>
              </VStack>
            </form>

          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default Login;
